export const SurveyAnswerStateKbnConst = {

  // アンケート回答ステータス区分
  SURVEY_ANSWER_STATE_KBN: '057',
  SURVEY_ANSWER_STATE_KBN_NOT_ANSWERED: '05701', // 未回答
  SURVEY_ANSWER_STATE_KBN_IS_ANSWERED: '05702', // 回答済み
  SURVEY_ANSWER_STATE_KBN_DUPLICATED: '05703', // 重複回答
} as const;
